// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_Zt4","cls2":"ActionNav-cls2_wnV ActionNav-cls1_Zt4"};